export default function() {
  const widgetName = 'seoWidget';
  const widgetOpts = seoWidgetOpts;

  function modifyTitle(data) {
    const widget = $(`#${widgetName}`);
    const title = data.items[0].Title;
    let subTitle = data.items[0].DetailLinkText;
    // limit subTitle lenght to 30 characters
    subTitle = subTitle.length > 30 ? subTitle.substring(0, 30) : subTitle;
    const fullTitle = `<h1 class="card-widget-title" aria-label="${subTitle} ${title}">
    <span class="main">${title}</span>
    <span class="sub">${subTitle}</span>
    </h1>`;
    widget.find('.card-widget-title').remove();
    widget.find('.card-content').prepend(fullTitle);
    $(`#${widgetName} .moreButton`).addClass('button');
  
  }
  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    cardWidgetLoaded: function(slides) {
      modifyTitle(slides);
    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 1,
    moreButton: {
      visible: true,
      text: 'Learn More'
    },
    scriptPath:  widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: false
  });

}